module.exports = __webpack_public_path__ + "img/timer-start.31e46582.svg";